import { Pipe, PipeTransform } from '@angular/core';

/**
 *
 */
@Pipe({ name: 'stringLength' })
export class StringLength implements PipeTransform {
  /**
   *
   * @param value
   * @returns {number}
   */
  transform(value: string, length: number): any {
    let returnString = '';
    if (value && value.length > length) {
      returnString = value.substring(0, length) + '...';
    } else {
      returnString = value;
    }

    return returnString;
    // var returnArray = [];
    // var stringArray = value.split(' ');
    // for(var i=0; i< stringArray.length; i++){
    // 	returnArray.push(stringArray[i].split('')[0]);
    // }
    // return returnArray.toString().replace(/,/g, '').toUpperCase();
  }
}
